import { useState } from "react";

export const faqs = [
  {
    question: "Peut-on réparer un moteur Somfy ou faut-il le changer ?",
    answer: "Dans près de 60 % des cas, une panne de moteur Somfy se répare sans remplacement. La télécommande io peut perdre son appairage après une coupure de courant, le récepteur RTS peut être en mode protection après une surcharge, ou le condensateur de démarrage peut être usé. Ces trois pannes se réparent en moins d'une heure. Si le moteur tubulaire est grippé, brûlé ou usé après plus de 15 ans de service, le remplacement est alors inévitable. Notre diagnostic gratuit vous permet de connaître la meilleure option.",
  },
  {
    question: "Quel est le prix d'un remplacement de moteur Somfy ?",
    answer: "Le prix dépend du modèle de moteur choisi (io pour la domotique, RTS pour la radio classique, ou filaire pour l'interrupteur mural), de la dimension du volet et du poids du tablier. Un moteur io pour une baie standard coûte plus cher qu'un moteur RTS du fait de la technologie bi-directionnelle. Nous vous établissons un devis gratuit sur place qui inclut le moteur, la pose, le recâblage, la reprogrammation des télécommandes Telis ou Situo, et la garantie décennale.",
  },
  {
    question: "Combien de temps dure l'intervention de remplacement ?",
    answer: "Un remplacement de moteur Somfy dure généralement entre 45 minutes et 1 heure 30, selon la complexité du recâblage et le nombre de commandes à reprogrammer. Un moteur filaire avec un seul interrupteur mural se remplace en moins d'une heure. Un moteur io avec trois télécommandes et une box TaHoma demande plus de temps pour l'appairage et la vérification du retour d'information. Nous arrivons avec les pièces nécessaires pour faire l'intervention en une seule visite.",
  },
  {
    question: "Gardez-vous mes télécommandes et commandes existantes ?",
    answer: "Oui, dans la majorité des cas. Les télécommandes Somfy Telis et Situo sont compatibles avec la plupart des moteurs de remplacement. Nous reprogrammons vos émetteurs existants et resynchronisons le moteur avec votre box domotique TaHoma ou Connexoon si vous en disposez d'une. Si vos commandes datent d'avant 2010 et utilisent un ancien protocole, nous vous proposons des remplacements compatibles io ou RTS. Vous ne payez que les pièces nécessaires.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold text-center mb-3">
          Questions fréquentes
        </h2>
        <p className="text-[#2F4A63] text-base text-center mb-10 md:mb-14">
          Tout ce que vous devez savoir sur le remplacement de moteur Somfy.
        </p>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-[#E2E8F0] overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <span className="text-[#143A66] font-semibold text-base pr-4">
                  {faq.question}
                </span>
                <span className="w-8 h-8 flex items-center justify-center shrink-0 rounded-full bg-[#00B3A4]/10">
                  <i
                    className={`ri-arrow-down-s-line text-[#00B3A4] text-lg transition-transform ${openIndex === index ? "rotate-180" : ""}`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <p className="text-[#2F4A63] text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}